var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.19 17.3H2.81C1.81 17.3 1 16.49 1 15.49V2.81C1 1.81 1.81 1 2.81 1H20.19C21.19 1 22 1.81 22 2.81V15.49C22 16.48 21.19 17.3 20.19 17.3Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.19 17.3H2.81C1.81 17.3 1 16.49 1 15.49V2.81C1 1.81 1.81 1 2.81 1H20.19C21.19 1 22 1.81 22 2.81V15.49C22 16.48 21.19 17.3 20.19 17.3Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33008 9.1499H7.26008",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.b9f24c73453cf5ecb2d2d541806442e4.svg";
export { ForwardRef as ReactComponent };